
<template>
  <g class="not-copy">
    <!-- 説明を書く欄を作る -->
    <g v-if="(!isMinimumDescription) && (scenario.status === 0 || scenario.status === 1 || scenario.status === 2 || scenario.status === 4 || scenario.status === 5|| scenario.status === 6 || scenario.status === 7 || scenario.status === 8 || scenario.status === 10)">
      <rect fill="white" :stroke="cursorColor" stroke-width="3" :x="scenario.beforenodeX + cursorBoxX + 20" :y="scenario.beforenodeY - 5" :width="cursorBoxX + 10" :height="cursorBoxY * 5.5" :rx="rxSize"></rect>
      <rect fill="white" :stroke="cursorColor" stroke-width="3" :x="scenario.beforenodeX + cursorBoxX + 20" :y="scenario.beforenodeY - 5" :width="cursorBoxX + 10" :height="cursorBoxY * 5.5" :rx="rxSize"></rect>
      <text fill="black" font-size="25" :x="scenario.beforenodeX + cursorBoxX + 30" :y="scenario.beforenodeY + 25">説明を入力</text>
      <rect @click="changeWindow()" :fill="cursorColor" :x="(scenario.beforenodeX) + (cursorBoxX * 2) - 15" :y="scenario.beforenodeY - 5" :width="nodeSize" :height="nodeSize" :rx="rxSize"></rect>
      <text @click="changeWindow()" fill="white" font-size="60" :x="(scenario.beforenodeX) + (cursorBoxX * 2) - 5" :y="scenario.beforenodeY + 35" :width="nodeSize" :height="nodeSize" :rx="rxSize">-</text>
      <foreignObject style="padding: 5px;" :x="scenario.beforenodeX + cursorBoxX + 20" :y="scenario.beforenodeY + 35" :width="cursorBoxX + 10" :height="cursorBoxY * 5.5" :rx="rxSize">
        <textarea class="input input-custom" @input="$store.dispatch('chatbot/descriptionChange', {scenario: scenario, description: description})" :style="{height: Number(cursorBoxY * 5.5 - 50) + 'px'}" v-model="description"></textarea>
      </foreignObject>
    </g>
    <!-- <g v-if="(!isMinimumDescription) && (scenario.status === 3 || scenario.status === 9)">
      <rect fill="#f2f2f2" :stroke="cursorColor" stroke-width="3" :x="scenario.beforenodeX + cursorBoxX - 20" :y="scenario.beforenodeY - 5" :width="cursorBoxX + 10" :height="cursorBoxY * 5.5" :rx="rxSize"></rect>
      <foreignObject style="padding: 5px;" :x="scenario.beforenodeX + cursorBoxX - 20" :y="scenario.beforenodeY - 5" :width="cursorBoxX + 10" :height="cursorBoxY * 5.5" :rx="rxSize">
        <textarea class="input input-custom" :style="{height: Number(cursorBoxY * 5.5 - 10) + 'px'}" v-model="description"></textarea>
      </foreignObject>
    </g> -->
    <g v-if="(isMinimumDescription) && (scenario.status === 0 || scenario.status === 1 || scenario.status === 2 || scenario.status === 4 || scenario.status === 5 || scenario.status === 6 || scenario.status === 7 || scenario.status === 8 || scenario.status === 10)">
      <rect @click="changeWindow()" :fill="cursorColor" :x="(scenario.beforenodeX) + cursorBoxX + 20" :y="scenario.beforenodeY" :width="nodeSize" :height="nodeSize" :rx="rxSize"></rect>
      <text @click="changeWindow()" fill="white" font-size="48" :x="(scenario.beforenodeX) + cursorBoxX + 25" :y="scenario.beforenodeY + 37.5" :width="nodeSize" :height="nodeSize" :rx="rxSize">+</text>
    </g>
    <!-- <g v-if="(isMinimumDescription) && (scenario.status === 3 || scenario.status === 9)">
      <rect @click="changeWindow()" :fill="cursorColor" :x="(scenario.beforenodeX) + cursorBoxX - 20" :y="scenario.beforenodeY - 5" :width="nodeSize" :height="nodeSize" :rx="rxSize"></rect>
      <text @click="changeWindow()" fill="white" font-size="48" :x="(scenario.beforenodeX) + cursorBoxX + 25" :y="scenario.beforenodeY + 32.5" :width="nodeSize" :height="nodeSize" :rx="rxSize">+</text>
    </g> -->
  </g>
</template>

<script>
import { mapState } from 'vuex'
import hex2rgb from '@/functions/hex2rgb'
export default {
  name: 'DescribeStore',
  componentName: 'DescribeStore',
  props: ['scenario', 'ratio', 'dx', 'dy'],
  computed: {
    ...mapState('chatbot', ['scenarioTable', 'chatbots', 'scenarioName', 'isSCNLoading', 'modalScenario', 'isConnecting', 'scenarioNodeData', 'nextNode', 'isRoboPartsSetView', 'selectScenarioList']),
    ...mapState('auth', ['botstatus', 'user']),
  },
  data () {
    return {
      isMinimumDescription: false,
      description: '',
      isMoveScenario: false,
      isLineNode: false,
      beforeMouseX: null,
      beforeMouseY: null,
      bgColorWhite: '#f8f8f8',
      bgColorLightBlue: '#ccfff2',
      bgColorMidBlue: '#65ffd8',
      bgColorBlue: '#00cb98',
      bgColorYellowList: ['#00cb98', '#CCFFCC'],
      startColorSetting: '#00cb98',
      bgColorFont: '#000',
      nodeSize: 45,
      startNodeSize: 25,
      rxSize: 5,
      fontSize: '12px',
      cursorBoxX: 310,
      cursorBoxY: 45,
      cursorColor: '#550011',
      cursorDasfOffset: 0,
      cursorDasfArray: 5,
      messageBoxX: 200,
      messageBoxY: 45,
      messageX: 190,
      messageY: 35,
      selectBoxX: 200,
      selectBoxY: 45,
      selectX: 190,
      selectY: 35,
      moveLineX: 0,
      moveLineY: 0,
      startLineX: 0,
      startLineY: 0,
      path: '',
      strokeWidth: '3',
      strokeFill: '#000',
      strokeOpacity: 0.5,
      isMouseout: false
    }
  },
  mounted () {
    console.debug('*** Start *** mounted')
    for (var i in this.selectScenarioList) {
      if (this.selectScenarioList[i].scenario.beforenode == this.scenario.beforenode) {
        this.isMinimumDescription = true
        this.description = this.selectScenarioList[i].description
      }
    }
    console.debug('*** End *** mounted')
  },
  methods: {
    changeWindow () {
      console.debug('*** Start *** changeWindow')
      this.isMinimumDescription = !this.isMinimumDescription
      console.debug('*** End *** changeWindow')
    }
  }
}
</script>

<style scoped>
.not-copy {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.input-custom {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/ChatBot/DescribeStore.vue